import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
// import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DataEntryStep1 } from '../../../models/data-entry-step1'
// import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../portalglobals'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { StateGateway } from '../../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import { NumericTextFieldValidator } from '../../../../validations/numeric-text-field-validator'
import { LengthTextFieldValidator } from '../../../../validations/length-text-field-validator'
import * as moment from 'moment'
import { CurrentUserGateway } from '../../../../common/gateways/current-user-gateway'
import { PreEnrollmentCallLogDetails } from '../../../models/PreEnrollmentCallLogDetails'
import { GoodStandingModel } from '../../../../common/models/good-standing-model'
import { UserDataService } from '../../../../user-management/gateways/user-data-service'
import { PhoneNumberInputMask } from '../../../../common/input-masks/phone-number.input-mask'
import { EnrollmentCacheData } from '../../../models/EnrollmentCacheData'
import { PlanList } from '../../../models/plan-list'

import { callStartGateway } from '../../../../call-start/gateways/call-start-gateway'
import { LicenseApptGateway } from '../../../../user-management/gateways/license-appt-gateway'
import { SubmitEnrollmentDataResponse } from './../../../models/submit-enrollment-data-response'
import { ValidatedDateTextField } from '../../../../validations/validated-date-text-field.component'
import * as _ from 'lodash'
import { RelationshipToEnrollee } from '../../../models/relationshipToEnrollee'
import { UtilsService } from '../../common/utils-service'
import { AuthService } from '../../../../auth/auth-service'
@Component({
    selector: 'PhoneEnrollmentStep1',
    templateUrl: 'phone-enrollment-step1.component.html',
    styleUrls: ['./phone-enrollment.component.scss']
})
export class PhoneEnrollmentStep1Component implements OnInit {
    public rblrecord: ValidatedRadioButtonModel[] = []
    public rblRep: ValidatedRadioButtonModel[] = []
    public rblBenfe: ValidatedRadioButtonModel[] = []
    public rblBenfereply: ValidatedRadioButtonModel[] = []

    public rblAuthorizedRep: ValidatedRadioButtonModel[] = []
    public ddllMailCopy: ValidatedSelectOptionModel[] = []
    rblRelation: ValidatedSelectOptionModel[] = []

    notBlankValidator = new NotBlankGenericFieldValidator()
    numericTextFieldValidator = new NumericTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)
    phoneNumberInputMask = new PhoneNumberInputMask()
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    @Input() states: State[] = [] as State[]
    @Input() authrepstates: State[] = [] as State[]
    validatedDate = new ValidatedDateTextField()
    dataEntryStep1 = {} as DataEntryStep1
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    callLog = {} as PreEnrollmentCallLogDetails
    rblrecordyes: boolean
    rblrecordno: boolean
    rblrepyes: boolean
    rblrepno: boolean
    rblbenfeyes: boolean
    rblbenfeno: boolean
    rblbenfereplyyes: boolean
    rblbenfereplyno: boolean
    hasError: boolean
    ErrorMessages: any[]
    agentUserName: string
    isValidAgent: boolean
    CUID: string
    AgentID: string
    isQtip: boolean
    IsPhoneEnrollmentAccess: boolean
    public sub: any
    calllogid: number
    insuranceComapny: string
    checkPlanyear: boolean = false
    selectedyear: number
    agentFullname: string

    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    ShowCurrentYearScript: boolean = false
    planList: PlanList[] = [] as PlanList[]
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    public loading: boolean = false
    planvalue: string

    UserState: string
    UILangEng: boolean
    IsSameAddress: boolean
    CheckGoodStanding: boolean = false
    mailingstates: State[] = [] as State[]
    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    titleOption: string = ''
    genderOption: string = ''
    planstatename: string
    rblbenfInfo: boolean
    spnyouheshe: string
    spnyouthey: string
    spnyourhisher: string
    spnyouhimher: string
    spnYouheshe: string
    spnIsBeneficiary2: string
    spnIsBeneficiary: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnYourBeneficiaryNew: string
    AgentFullName: string
    spnIsBeneficiaryYou: string
    spndodoes: string
    spnyoubenef: string
    spnYoutheenrollee: string
    spnnameofMedicare: string
    disabled: boolean
    visibleFrom2025: boolean
    isMyAplgy: boolean = false
    isVisibleIndiv: boolean = true
    isAppInd: boolean

    constructor(
        public _global: PortalGlobals,
        private router: Router,
        private _licenseAppGateway: LicenseApptGateway,
        private _stateGateway: StateGateway,
        private route: ActivatedRoute,
        private _currentUserGateway: CurrentUserGateway,
        private _enrollementGateway: EnrollmentGateway,
        private userdataservice: UserDataService,
        private _callStartGateway: callStartGateway,
        private utils: UtilsService,
        private _authService: AuthService
    ) {
        this.rblrecord.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblRep.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblBenfe.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblBenfereply.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })

        this.rblAuthorizedRep.push({ value: 'No', htmlLabel: 'No' }, { value: 'Yes', htmlLabel: 'Yes' })
        this.ddllMailCopy.push({ value: 'No', text: 'No' }, { value: 'Yes', text: 'Yes' })
        this.rblRelation.push(
            { value: 'Aunt', text: 'Aunt' },
            { value: 'Brother', text: 'Brother' },
            { value: 'Caretaker', text: 'Caretaker' },
            { value: 'Case Worker', text: 'Case Worker' },
            { value: 'Companion', text: 'Companion' },
            { value: 'Cousin', text: 'Cousin' },
            { value: 'Daughter', text: 'Daughter' },
            { value: 'Daughter In Law', text: 'Daughter In Law' },
            { value: 'Father', text: 'Father' },
            { value: 'Father In Law', text: 'Father In Law' },
            { value: 'Friend', text: 'Friend' },
            { value: 'Grand Daughter', text: 'Grand Daughter' },
            { value: 'Grand Son', text: 'Grand Son' },
            { value: 'Home Provider', text: 'Home Provider' },
            { value: 'Hospice', text: 'Hospice' },
            { value: 'Husband', text: 'Husband' },
            { value: 'Mother In Law', text: 'Mother In Law' },
            { value: 'Mother', text: 'Mother' },
            { value: 'Nephew', text: 'Nephew' },
            { value: 'Niece', text: 'Niece' },
            { value: 'Power of Attorney', text: 'Power of Attorney' },
            { value: 'Program Coordinator', text: 'Program Coordinator' },
            { value: 'Other', text: 'Other' },
            { value: 'Residential Support', text: 'Residential Support' },
            { value: 'Son In Law', text: 'Son In Law' },
            { value: 'Sister', text: 'Sister' },
            { value: 'Son', text: 'Son' },
            { value: 'Social Worker', text: 'Social Worker' },
            { value: 'Step Daughter', text: 'Step Daughter' },
            { value: 'Step Son', text: 'Step Son' },
            { value: 'Wife', text: 'Wife' },
            { value: 'Spouse', text: 'Spouse' }
        )
        this._stateGateway.getAllStates().subscribe((states: State[]) => (this.authrepstates = states))
        this.rblrecordyes = true
        this.rblrecordno = true

        this.rblrepyes = true
        this.rblrepno = true

        this.rblbenfereplyyes = true
        this.rblbenfereplyno = true

        this.rblbenfeyes = true
        this.rblbenfeno = true

        this.ErrorMessages = [] as any[]

        this.enrollment.AUTHREPIND = 'No'
        this.IsSameAddress = true
        this.rblbenfInfo = true
        this.disabled = false
    }

    ngOnInit() {
        this.UILangEng = true
        //Remove session object for enrollment cache
        if (sessionStorage.getItem('EnrollmentCache') != null) {
            sessionStorage.removeItem('EnrollmentCache')
        }

        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        }
        this._authService.isAuthorization('phone-enrollment')

        this.enrollment.FORMNAME = 'PHONEENROLLMENT'
        if (this._global === undefined || this._global.currentUser === undefined || this._global.currentUser.insuranceCompanyName === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                    this.agentUserName = this._global.currentUser.userProfileName
                    this.AgentID = this._global.currentUser.userProfileId.toString()
                    this.agentFullname = this._global.currentUser.firstName + ' ' + this._global.currentUser.lastName
                    this.setData()
                    this.setPageData()
                }
            })
        } else {
            if (this._global.currentUser.insuranceCompanyName !== undefined) {
                this.insuranceComapny = this._global.currentUser.insuranceCompanyName
            }
            this.isQtip = false
            if (this._global.currentUser.userProfileName !== undefined) {
                this.agentUserName = this._global.currentUser.userProfileName
            }
            if (this._global.currentUser.userProfileId !== undefined) {
                this.AgentID = this._global.currentUser.userProfileId.toString()
            }
            if (this._global.currentUser.firstName !== undefined) {
                this.agentFullname = this._global.currentUser.firstName + ' ' + this._global.currentUser.lastName
            }

            this.setData()
            this.setPageData()
        }

        //Check phone enrollment access using bookmark and redirected them accordingly.
        //this.CheckPhoneEnrllAccess()
    }

    setData(): void {
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        if (this._global.currentUser.isCallCenterAgent) {
            this.CheckGoodStanding = true
        }

        if (this.enrollment.CALLOGID !== undefined && this.enrollment.CALLOGID !== 0) {
            this.calllogid = this.enrollment.CALLOGID
            this.isQtip = true
            this.selectedyear = Number(this.enrollment.PLANYEAR)
            if (this.selectedyear === this._global.PreviousPlanYear) {
                this.ShowCurrentYearScript = true
            }

            //Get the state using ZIPCODE
            this._callStartGateway.getStateByZipCode(this.enrollment.APPZIP).subscribe((data: any) => {
                if (data !== null || data !== undefined) {
                    this.UserState = data
                }
            })

            this.loadPlanList(this.selectedyear.toString())
        } else {
            this.sub = this.route.params.subscribe((params) => {
                this.calllogid = +params['callLogID']
                this.selectedyear = +params['planyear']

                if (this.selectedyear.toString() === 'NaN' || this.selectedyear.toString() === '0' || this.selectedyear === undefined) {
                    this.selectedyear = this._global.selectedPlanYear
                }
                if (this.selectedyear === this._global.PreviousPlanYear) {
                    this.ShowCurrentYearScript = true
                }

                if (this.calllogid !== undefined && this.calllogid !== null) {
                    if (this.calllogid === 0) {
                        this.enrollment = {} as EnrollmentViewModel
                        this.loadPlanList(this.selectedyear.toString())
                    } else {
                        this._enrollementGateway.GetPreEnrollmentBeneficiaryDtl(this.calllogid).subscribe((PreEnrollmentCallLogDetails) => {
                            if (PreEnrollmentCallLogDetails !== null && PreEnrollmentCallLogDetails !== undefined) {
                                this.callLog = PreEnrollmentCallLogDetails
                                this.enrollment = {} as EnrollmentViewModel
                                this.fillCallLogDetails()

                                //Get the state using ZIPCODE
                                this._callStartGateway.getStateByZipCode(this.callLog.Zipcode).subscribe((data: any) => {
                                    if (data !== null || data !== undefined) {
                                        this.UserState = data
                                    }
                                })

                                this.isQtip = true
                                //if (this.enrollment.AUTHREPCOPYIND === null || this.enrollment.AUTHREPCOPYIND === ''
                                //    || this.enrollment.AUTHREPCOPYIND === undefined) {
                                //    this.enrollment.AUTHREPCOPYIND = 'No'
                                // }
                            }
                            this._enrollementGateway.setPreEnrollmentCallLogDetails(PreEnrollmentCallLogDetails)
                            this.loadPlanList(this.selectedyear.toString())
                        })
                    }
                }
            })

            if (this.calllogid.toString() === 'NaN' || this.calllogid.toString() === '0' || this.calllogid === undefined) {
                this.loadPlanList(this.selectedyear.toString())
            }
        }

        this.SelectRblrecordOptions(this.enrollment.RBLRECORD)
        this.SelectRblrecordNoOptions(this.enrollment.RBLREP)
        this.SelectRblrblBenfeOptions(this.enrollment.RBLBENFE)
        this.SelectRblrblBenfeReplyOptions(this.enrollment.RBLBENFEREPLY)
        this.selectRblIndRepInd(this.enrollment.INDREPIND)
        if (this.enrollment.PLANTYPE != null && this.enrollment.PLANTYPE != '' && this.enrollment.PLANTYPE != undefined) {
            if (this.enrollment.APPST != null && this.enrollment.APPST != '' && this.enrollment.APPST != undefined) {
                this.UserState = this.enrollment.APPST
            }
            this.setplanValue(this.enrollment.PLANTYPE)
        }
        //if (this.enrollment.AUTHREPCOPYIND === null || this.enrollment.AUTHREPCOPYIND === ''
        //    || this.enrollment.AUTHREPCOPYIND === undefined) {
        //    this.enrollment.AUTHREPCOPYIND = 'No'
        //}
        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.visibleFrom2025 = true
        }

        // if (this.ShowCurrentYearScript) {
        //  this.rblrecordno = false
        // }
        //this.setPageData()
    }

    setplanValue(planType: string): void {
        this._enrollementGateway
            .getPlanPremium(Number(this._global.currentUser.orgId), this.selectedyear.toString(), planType, this.UserState)
            .subscribe((model: string) => {
                this.planvalue = model
            })
    }

    onPlanChange(planType: string) {
        if (planType !== undefined && planType !== '' && planType !== null) {
            this.enrollment.PLANTYPE = planType
            if (this.optionrbPlan !== undefined && this.optionrbPlan !== null) {
                if (this.optionrbPlan.length > 0) this.enrollment.PLANTYPENAME = this.optionrbPlan.filter((x) => x.value === planType)[0].htmlLabel
                if (this.UserState !== undefined && this.UserState !== null && this.UserState != '') this.setplanValue(this.enrollment.PLANTYPE)
            }
        }
    }

    loadPlanList(PLANYEAR: string) {
        if (PLANYEAR !== null) {
            this.loading = true
            this._enrollementGateway.getPlanList(parseInt(this._global.currentUser.orgId), PLANYEAR).subscribe(
                (model: PlanList[]) => {
                    this.planList = model
                    this.getPlanList(this.planList)

                    //this.setData()
                    this.loading = false
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    private getPlanList(planLst: PlanList[]) {
        this.optionrbPlan = planLst.map(this.buildPlanOption.bind(this))
    }

    private buildPlanOption(plan: PlanList): ValidatedRadioButtonModel {
        return {
            value: plan.PlanTypeShortName,
            htmlLabel: plan.PlanTypeName
        }
    }

    SelectRblrecordOptions(isRblrecord: string) {
        if (isRblrecord === 'Yes') {
            this.rblrecordyes = true
            this.rblrecordno = false

            if (!this.ShowCurrentYearScript) {
                //this.rblrecordyes = false
                //this.rblrecordno = true

                this.rblrepyes = false
                this.rblrepno = true
                this.rblbenfInfo = true
            }
        }
        if (isRblrecord === 'No') {
            this.rblrecordyes = false
            this.rblrecordno = true
            if (this.calllogid !== undefined && this.calllogid !== null && this.calllogid > 0) {
                this.isQtip = true
            }
        }
        this.enrollment.RBLRECORD = isRblrecord
    }
    SelectRblrecordNoOptions(isRblrep: string) {
        if (isRblrep === 'Yes') {
            this.rblrepyes = true
            this.rblrepno = false
            this.rblbenfInfo = true
        }
        if (isRblrep === 'No') {
            this.rblrepyes = false
            this.rblrepno = true
            this.rblbenfInfo = true
        }
        this.enrollment.RBLREP = isRblrep
    }
    SelectRblrblBenfeOptions(isRblBene: string) {
        if (isRblBene === 'Yes') {
            this.rblbenfeyes = true
            this.rblbenfeno = false
            this.rblbenfInfo = false
            this.rblbenfereplyno = true
            this.enrollment.RBLBENFEREPLY = ''
            this.enrollment.INDREPIND = ''
            this.isVisibleIndiv = false
            this.showMyapologies()
        }
        if (isRblBene === 'No') {
            this.rblbenfeyes = false
            this.rblbenfeno = true
            this.rblbenfInfo = true
            this.isVisibleIndiv = true
        }

        this.enrollment.RBLBENFE = isRblBene
        this.setScript()
        //this.rblbenfereplyyes = null
        //this.rblbenfereplyno = null
    }
    rblAppIndINDClick(isAppInd: boolean) {
        this.isAppInd = isAppInd
        this.showMyapologies()
    }
    showMyapologies() {
        if (this.visibleFrom2025) {
            if (this.enrollment.INDREPIND === 'No' && this.enrollment.RBLBENFEREPLY === 'No') {
                this.isMyAplgy = true
            } else {
                this.isMyAplgy = false
            }
        } else {
            if (this.enrollment.INDREPIND === 'No') {
                this.isMyAplgy = true
            } else {
                this.isMyAplgy = false
            }
        }
    }
    SelectRblrblBenfeReplyOptions(isRblBeneReply: string) {
        if (isRblBeneReply === 'Yes') {
            this.rblbenfereplyyes = true
            this.rblbenfereplyno = false
            this.rblbenfeno = false
            this.rblbenfInfo = false
        }
        if (isRblBeneReply === 'No') {
            this.rblbenfereplyyes = false
            this.rblbenfereplyno = true
            this.rblbenfeno = true
            this.rblbenfInfo = true
        }
        this.enrollment.RBLBENFEREPLY = isRblBeneReply
        this.showMyapologies()
    }
    selectRblIndRepInd(isIndRepInd: string) {
        if (isIndRepInd === 'Yes') {
            this.isAppInd = true
        }
    }

    BenfDetails() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/BeneficiaryDetails'])
    }
    SalesBenfDetails() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/BeneficiaryDetails/6'])
    }
    formSubmit(): void {
        if (this._global.currentUser.userProfileName !== null && sessionStorage.getItem('GoodStandingParams') !== null) {
            this.hasError = false
            this.ErrorMessages = [] as any[]
            this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
            if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                this.hasError = true
                if (!this.goodStandingValues.CurriculumStatus) {
                    this.ErrorMessages.push(
                        this._global.currentUser.userProfileName + ' has not passed training for ' + this._global.selectedPlanYear + '<br/>'
                    )
                }
                if (!this.goodStandingValues.BackgroundCheckStatus) {
                    this.ErrorMessages.push(this._global.currentUser.userProfileName + ' background check not approved.<br/>')
                }
                if (!this.goodStandingValues.LicenseStatus) {
                    this.ErrorMessages.push(this._global.currentUser.userProfileName + ' does not have any valid license.<br/>')
                }
                return
            }
            if (!this.hasError) {
                this.validateForm()
            }
        }
    }

    saveData() {
        this.enrollment.AGENTDEX = 'ICALL'
        this.enrollment.DEX = 'ICALL'
        this.enrollment.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollment.STEPCODE = '1'
        this.enrollment.ADMINID = this._global.currentUser.userProfileId
        //this.enrollment.AGENTID = String(this._global.currentUser.userProfileId)
        this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
        this.enrollment.INSURANCECOMPID = Number(this._global.currentUser.insuranceCompanyId)
        // this.enrollment.PLANYEAR = this._global.selectedPlanYear.toString()
        if (this.selectedyear.toString() === 'NaN' || this.selectedyear.toString() === '0' || this.selectedyear === undefined) {
            this.enrollment.PLANYEAR = this._global.selectedPlanYear.toString()
        } else {
            this.enrollment.PLANYEAR = this.selectedyear.toString()
        }
        this.enrollment.AGENTNAME = this.agentUserName
        this.enrollment.AGENTID = this._global.currentUser.userProfileId.toString()
        this.enrollment.USERNAME = this._global.currentUser.userProfileName
        this.enrollment.CUID = this.CUID
        if (this.CUID === '9110') {
            this.enrollment.STEEREDIND = false
        } else {
            this.enrollment.STEEREDIND = true
        }
        this.enrollment.DATEOFRECEIPT = new Date()
        if (!this.rblbenfereplyno && !this.rblbenfeyes) {
            this.enrollment.AUTHREPIND = 'Yes'
        } else {
            this.enrollment.AUTHREPIND = 'No'
        }
        this.enrollment.CALLOGID = this.calllogid
        if (this.enrollment.ISSAMEADDRESS) {
            this.enrollment.MAILADD1 = this.enrollment.APPADD1
            this.enrollment.MAILADD2 = this.enrollment.APPADD2
            this.enrollment.MAILCITY = this.enrollment.APPCITY
            this.enrollment.MAILST = this.enrollment.APPST
            this.enrollment.MAILZIP = this.enrollment.APPZIP
        }
        if (this.enrollment.POBOX) {
            this.enrollment.POVERIND = '1'
        } else {
            this.enrollment.POVERIND = '0'
        }
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        //this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/Step2'])
        this.loading = true
        let mailStateCode = this.enrollment.MAILST
        let mailZip = this.enrollment.MAILZIP
        if (this.enrollment.SAMEADDRESS) {
            mailStateCode = '0'
            mailZip = '0'
        }

        this._enrollementGateway
            .validateZipForAll(
                this.enrollment.APPST,
                this.enrollment.APPZIP,
                mailStateCode,
                mailZip,
                this.enrollment.AUTHREPST,
                this.enrollment.AUTHREPZIP
            )
            .subscribe(
                (model: string[]) => {
                    if (model !== undefined && model !== null && model.length !== 0) {
                        this.ErrorMessages = model
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                        this.loading = false
                    } else {
                        this._enrollementGateway.SubmitEnrollmentData(this.enrollment).subscribe(
                            (model: SubmitEnrollmentDataResponse) => {
                                let response = model
                                if (response !== undefined) {
                                    if (response.Errors !== undefined && response.Errors.length > 0) {
                                        this.hasError = false

                                        for (let i = 0; i < response.Errors.length; i++) {
                                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                        }
                                        this.loading = false
                                        this.hasError = true
                                        window.scrollTo(0, 0)
                                    } else {
                                        if (
                                            response.EnrollmentKey !== undefined &&
                                            response.EnrollmentKey !== '' &&
                                            response.EnrollmentKey !== null
                                        ) {
                                            this.enrollment.ENROLLKEY = response.EnrollmentKey
                                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                            this.loading = false

                                            this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                                            this.enrollmentCacheData.AgentName = this.enrollment.AGENTNAME
                                            this.enrollmentCacheData.AgentID = this.enrollment.AGENTID
                                            this.enrollmentCacheData.AdminID = this.enrollment.ADMINID
                                            this.enrollmentCacheData.AgentOrgID = this.enrollment.AGENTORGID
                                            this.enrollmentCacheData.USERNAME = this.enrollment.USERNAME
                                            this.enrollmentCacheData.FORMNAME = this.enrollment.FORMNAME
                                            this.enrollmentCacheData.PlanYear = this._global.selectedPlanYear
                                            this.enrollmentCacheData.CALLOGID = this.enrollment.CALLOGID
                                            this.enrollmentCacheData.RBLBENFE = this.enrollment.RBLBENFE

                                            sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                                            this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/Step2'])
                                        } else {
                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                            this.hasError = true
                                            this.loading = false
                                        }
                                        this.loading = false
                                    }
                                    this.loading = false
                                } else {
                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                    this.hasError = true
                                    this.loading = false
                                    window.scrollTo(0, 0)
                                }
                                this.loading = false
                            },
                            (err) => {
                                this.loading = false
                            }
                        )
                    }
                },
                (err) => {
                    this.loading = false
                }
            )

        // }
    }

    validateForm() {
        this.hasError = false
        this.ErrorMessages = [] as any[]
        this._enrollementGateway.isValidAgent(this.agentUserName).subscribe((validAgentModel) => {
            let isagentvalid = true
            if (
                validAgentModel !== undefined &&
                validAgentModel.errorMessage !== '' &&
                validAgentModel.errorMessage !== null &&
                validAgentModel.errorMessage !== undefined
            ) {
                this.ErrorMessages.push(validAgentModel.errorMessage)
                isagentvalid = false
            }
            this.isValidAgent = isagentvalid
            if (!this.isValidAgent) {
                this.hasError = true
                this.focusableEleTop.nativeElement.focus()
            } else {
                this.hasError = false
                this.CUID = validAgentModel.CUID
                this.AgentID = String(validAgentModel.agentID)
            }
            if (this.CUID === undefined || this.CUID === '' || this.CUID === null) {
                this.ErrorMessages.push('CUID is required')
                this.hasError = true
            }

            if (this.enrollment.PLANTYPE === undefined || this.enrollment.PLANTYPE === '') {
                this.ErrorMessages.push('Plan Type is required')
                this.hasError = true
            }

            //check beneficiary data
            if (!this.rblbenfInfo) {
                this.checkBenficiaryValidation()
            }
            // check authorize reprenatative
            if (!this.rblbenfereplyno && !this.rblbenfeyes) {
                if (this.enrollment.AUTHREPNAME === undefined || this.enrollment.AUTHREPNAME === '') {
                    this.ErrorMessages.push('Authorized Representative Name is required')
                    this.hasError = true
                }
                if (this.enrollment.AUTHREPST === undefined || this.enrollment.AUTHREPST === '') {
                    this.ErrorMessages.push('Authorized Representative State is required')
                    this.hasError = true
                }
                if (this.enrollment.AUTHREPADD1 === undefined || this.enrollment.AUTHREPADD1 === '') {
                    this.ErrorMessages.push('Authorized Representative Address is required')
                    this.hasError = true
                }
                if (this.enrollment.AUTHREPCITY === undefined || this.enrollment.AUTHREPCITY === '') {
                    this.ErrorMessages.push('Authorized Representative City is required')
                    this.hasError = true
                }
                if (this.enrollment.AUTHREPZIP === undefined || this.enrollment.AUTHREPZIP === '') {
                    this.ErrorMessages.push('Authorized Representative Zip is required')
                    this.hasError = true
                }
                if (this.enrollment.AUTHREPREL === undefined || this.enrollment.AUTHREPREL === '') {
                    this.ErrorMessages.push('Authorized Representative Relationship is required')
                    this.hasError = true
                }
                if (this.enrollment.AUTHREPNAME !== undefined && this.enrollment.AUTHREPNAME !== '' && this.enrollment.AUTHREPNAME !== null) {
                    let checkLName = this.enrollment.AUTHREPNAME,
                        regexFNameVal = new RegExp('^[a-zA-Z- ]*$')
                    let isLnameValid = regexFNameVal.test(checkLName)
                    if (!isLnameValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Authorized Representative Relationship Name is invalid')
                    }
                }
                if (this.enrollment.AUTHREPPHONE !== undefined && this.enrollment.AUTHREPPHONE !== '' && this.enrollment.AUTHREPPHONE !== null) {
                    let checkOrgPhone = this.enrollment.AUTHREPPHONE.replace(/-/g, '')
                    if (/^\d{10}$/.test(checkOrgPhone)) {
                    } else {
                        if (!this.isValidNumber(checkOrgPhone)) {
                            this.ErrorMessages.push('Authorized Representative Phone Number is invalid')
                            this.hasError = true
                        } else {
                            this.ErrorMessages.push('Authorized Representative Phone Number is invalid')
                            this.hasError = true
                        }
                    }
                }
                if (this.enrollment.AUTHREPZIP !== undefined && this.enrollment.AUTHREPZIP !== '' && this.enrollment.AUTHREPZIP !== null) {
                    let checkZipCode = this.enrollment.AUTHREPZIP,
                        regexVal = new RegExp('[0-9]{5}')
                    let isZipCodeValid = regexVal.test(checkZipCode)
                    if (!isZipCodeValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Authorized Representative Zip is invalid')
                    }
                    //else {
                    //    this._enrollementGateway.validateZipCode(this.enrollment.AUTHREPST, this.enrollment.AUTHREPZIP)
                    //        .subscribe(
                    //        (model: string) => {
                    //            if (model !== undefined && model !== null && model.length !== 0) {
                    //                this.ErrorMessages.push(model)
                    //                this.hasError = true
                    //                this.focusableEleTop.nativeElement.focus()
                    //            } else {

                    //            }
                    //        })
                    //}
                }
                if (this.enrollment.AUTHREPEMAIL !== undefined && this.enrollment.AUTHREPEMAIL !== '') {
                    let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                    let checkOrgEmail = this.enrollment.AUTHREPEMAIL.toLowerCase()

                    let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                    if (!isOrgEmailValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Authorized Representative Email Address is invalid.')
                    }
                    //this.ErrorMessages.push('Email Address is required for Electronic Explanation of Benefits')
                    //this.hasError = true
                }
                this.focusableEleTop.nativeElement.focus()
            }
            if (this.enrollment.RBLBENFE === undefined || this.enrollment.RBLBENFE === null || this.enrollment.RBLBENFE == '') {
                this.ErrorMessages.push('Beneficiary is required')
                this.hasError = true
            }
            if (this.enrollment.RBLBENFE === 'No') {
                if (this.enrollment.RBLBENFEREPLY === undefined || this.enrollment.RBLBENFEREPLY === null || this.enrollment.RBLBENFEREPLY == '') {
                    this.ErrorMessages.push('Authorized Representative is required')
                    this.hasError = true
                }
            }

            if (this.enrollment.INDREPIND === 'Yes') {
                if (this.enrollment.INDREPNAME === undefined || this.enrollment.INDREPNAME === null || this.enrollment.INDREPNAME == '') {
                    this.ErrorMessages.push('Individual Rep Name is required')
                    this.hasError = true
                }
                if (this.enrollment.RELTOENROLL === undefined || this.enrollment.RELTOENROLL === null || this.enrollment.RELTOENROLL == '') {
                    this.ErrorMessages.push('Relationship to enrollee is required')
                    this.hasError = true
                }
                if (
                    (this.enrollment.displayRELTOENROLL == 'Agent' || this.enrollment.displayRELTOENROLL == 'Broker') &&
                    (this.enrollment.NPN === undefined || this.enrollment.NPN === null || this.enrollment.NPN == '')
                ) {
                    this.ErrorMessages.push('National Producer Number is required')
                    this.hasError = true
                }

                if (this.enrollment.NPN != undefined && this.enrollment.NPN != null && this.enrollment.NPN != '') {
                    if (!this.utils.isValidNPN(this.enrollment.NPN)) {
                        this.hasError = true
                        this.ErrorMessages.push('Invalid NPN')
                    }
                }
            }
            if (!this.hasError) {
                // if (this.rblbenfeyes)
                if (this.rblbenfereplyno) {
                    this.enrollment.AUTHREPNAME = ''
                    this.enrollment.AUTHREPPHONE = ''
                    this.enrollment.AUTHREPREL = ''
                    this.enrollment.AUTHREPADD1 = ''
                    this.enrollment.AUTHREPCITY = ''
                    this.enrollment.AUTHREPST = ''
                    this.enrollment.AUTHREPZIP = ''
                    this.enrollment.AUTHREPCOPYIND = ''
                    this.enrollment.AUTHREPSIGNEDIND = false

                    // Remove data for the Indiviudal
                    //this.enrollment.RELTOENROLL = '';
                    //this.enrollment.displayRELTOENROLL = '';
                    //this.enrollment.NPN = '';
                    //this.enrollment.INDREPNAME = '';
                }

                this.saveData()
            } else {
                this.focusableEleTop.nativeElement.focus()
            }
        })

        // return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
    fillCallLogDetails() {
        if (this.calllogid !== undefined && this.calllogid !== null && this.callLog !== undefined && this.callLog !== null) {
            this.enrollment.APPFN = this.callLog.FirstName
            this.enrollment.APPLN = this.callLog.LastName
            this.enrollment.APPGEN = this.callLog.Gender
            this.enrollment.HICN = this.callLog.MedicareId
            this.enrollment.APPADD1 = this.callLog.StreetAddress
            this.enrollment.APPCITY = this.callLog.City
            this.enrollment.APPST = this.callLog.StateAbbreviation
            this.enrollment.APPZIP = this.callLog.Zipcode
            this.enrollment.APPEMAIL = this.callLog.Email
            if (this.callLog.DateOfBirth != undefined) {
                //let dobdate = moment(this.callLog.DateOfBirth, 'MM/DD/YYYY')
                let dobdate = moment(this.callLog.DateOfBirth).format('MM/DD/YYYY')

                //let datess = moment(this.callLog.DateOfBirth, 'MM/DD/YYYY').format().split("T")[0]
                if (dobdate !== '01/01/0001' && dobdate != null && dobdate !== '01/01/1900' && dobdate != 'Invalid date') {
                    this.enrollment.APPDOB = moment(this.callLog.DateOfBirth).toDate()
                }
            }
            this.enrollment.APPPHONE = this.callLog.PhoneNumber
            this.enrollment.TITLE = this.callLog.Title
            this.enrollment.IsBeneficiary = this.callLog.IsBeneficiary
            this.enrollment.CALLOGID = this.calllogid
            this.enrollment.CALLENROLLMENTSTARTTIME = moment().format('YYYY-MM-DD')

            this.enrollment.APPADD2 = this.callLog.Address2
            this.enrollment.SUFFIX = this.callLog.Suffix
            this.enrollment.APPMI = this.callLog.MiddleInitial
            this.enrollment.LANG = this.callLog.Lang
            if (this.enrollment.LANG != undefined && this.enrollment.LANG != null) {
                if (this.enrollment.LANG == 'Spanish') {
                    this.UILangEng = false
                }
            } else {
                this.UILangEng = true
            }
            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        }
    }

    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }

    setPageData() {
        if (this._global.currentUser.orgId !== undefined) {
            if (this.CheckGoodStanding) {
                //For Call agent Set STEEREDIND=true
                this.enrollment.STEEREDIND = true

                //Get License state for care rep
                if (this.enrollment.AGENTNAME === undefined || this.enrollment.AGENTNAME === '')
                    this.enrollment.AGENTNAME = this._global.currentUser.userProfileName

                this._licenseAppGateway.getUserLicenseDetailsForEnrollment(this.enrollment.AGENTNAME).subscribe((state) => {
                    for (let i = 0; i < state.length; i++) {
                        this.states.push({ value: state[i].value, text: state[i].text })
                    }

                    _.remove(this.states, function (sta) {
                        return sta.value === 'PR' || sta.value === 'VI'
                    })

                    this.states.unshift({ value: '0', text: '-- Choose One --' })

                    if (
                        this.enrollment.APPST === undefined ||
                        this.enrollment.APPST === '' ||
                        this.enrollment.APPST === '0' ||
                        this.enrollment.APPST === null
                    ) {
                        this.enrollment.APPST = '0'
                    }
                    //this.setData()
                    this.setBeneficiaryData()
                })

                this._enrollementGateway
                    .GetAllParentStatesForOrg(parseInt(this._global.currentUser.orgId))
                    .subscribe((states: ValidatedSelectOptionModel[]) => {
                        states.unshift({ value: '0', text: '-- Choose One --' })

                        _.remove(states, function (sta) {
                            return sta.value === 'PR' || sta.value === 'VI'
                        })

                        this.mailingstates = states

                        if (
                            this.enrollment.MAILST === undefined ||
                            this.enrollment.MAILST === '' ||
                            this.enrollment.MAILST === '0' ||
                            this.enrollment.MAILST === null
                        ) {
                            this.enrollment.MAILST = '0'
                        }
                        this.setBeneficiaryData()
                        //this.mailingstates.unshift({ value: 0, text: '-- Choose One --', })
                    })
            } else {
                this._enrollementGateway
                    .GetAllParentStatesForOrg(parseInt(this._global.currentUser.orgId))
                    .subscribe((states: ValidatedSelectOptionModel[]) => {
                        states.unshift({ value: '0', text: '-- Choose One --' })
                        _.remove(states, function (sta) {
                            return sta.value === 'PR' || sta.value === 'VI'
                        })

                        this.mailingstates = states
                        this.states = states
                        if (
                            this.enrollment.APPST === undefined ||
                            this.enrollment.APPST === '' ||
                            this.enrollment.APPST === '0' ||
                            this.enrollment.APPST === null
                        ) {
                            this.enrollment.APPST = '0'
                        }
                        if (
                            this.enrollment.MAILST === undefined ||
                            this.enrollment.MAILST === '' ||
                            this.enrollment.MAILST === '0' ||
                            this.enrollment.MAILST === null
                        ) {
                            this.enrollment.MAILST = '0'
                        }
                        this.setBeneficiaryData()
                        //this.mailingstates.unshift({ value: 0, text: '-- Choose One --', })
                    })
            }
        } else {
            this.setBeneficiaryData()
        }
    }

    setBeneficiaryData() {
        this.titleOptions = [
            { value: 'MR', text: 'MR' },
            { value: 'MRS', text: 'MRS' },
            { value: 'DR', text: 'DR' },
            { value: 'MS', text: 'MS' }
        ]

        this.genderOptions = [
            { value: 'M', htmlLabel: 'M' },
            { value: 'F', htmlLabel: 'F' }
        ]

        if (this.enrollment.POVERIND !== '' && this.enrollment.POVERIND !== null && this.enrollment.POVERIND !== undefined) {
            if (this.enrollment.POVERIND == '1') {
                this.enrollment.POBOX = true
            } else {
                this.enrollment.POBOX = false
            }
        }

        if (this.enrollment.ISSAMEADDRESS !== null && this.enrollment.ISSAMEADDRESS !== undefined) {
            this.clickOnSameAsBusinessAddress(this.enrollment.ISSAMEADDRESS)
        }

        if (this.enrollment.APPST !== '' && this.enrollment.APPST !== null && this.enrollment.APPST !== undefined) {
            this.SelectState(this.enrollment.APPST)
        }

        if (this.enrollment.CALLOGID !== 0 && this.enrollment.CALLOGID !== null && this.enrollment.CALLOGID !== undefined) {
            this.isQtip = true
        }
        this.AgentFullName =
            (this.enrollment.APPFN === null ? '' : this.enrollment.APPFN) + ' ' + (this.enrollment.APPLN === null ? '' : this.enrollment.APPLN)
        this.setScript()
        if (this.enrollment.APPGEN !== '' && this.enrollment.APPGEN !== null && this.enrollment.APPGEN !== undefined) {
            this.SelectGender(this.enrollment.APPGEN)
        }
    }
    clickOnSameAsBusinessAddress(val: boolean) {
        if (val) {
            this.IsSameAddress = false
            this.enrollment.MAILADD1 = this.enrollment.APPADD1
            this.enrollment.MAILADD2 = this.enrollment.APPADD2
            this.enrollment.MAILCITY = this.enrollment.APPCITY
            this.enrollment.MAILST = this.enrollment.APPST
            this.enrollment.MAILZIP = this.enrollment.APPZIP
        } else {
            this.IsSameAddress = true
            this.enrollment.MAILADD1 = ''
            this.enrollment.MAILADD2 = ''
            this.enrollment.MAILCITY = ''
            this.enrollment.MAILST = ''
            this.enrollment.MAILZIP = ''
        }

        //  this.sameAsBusinessAddress = !this.sameAsBusinessAddress
        this.enrollment.ISSAMEADDRESS = val
    }
    SelectState(selectstate: string) {
        if (selectstate !== '' && selectstate !== undefined && selectstate !== '0') {
            this.planstatename = selectstate
        }
        this.enrollment.APPST = selectstate
        this.UserState = this.enrollment.APPST
        if (this.states !== undefined && this.states !== null) {
            if (this.states.length > 0) this.planstatename = this.states.filter((x) => x.value === selectstate)[0].text
        }
        if (this.enrollment.PLANTYPE != null && this.enrollment.PLANTYPE != '' && this.enrollment.PLANTYPE != undefined) {
            if (this.UserState != undefined && this.UserState != null && this.UserState != '') {
                this.setplanValue(this.enrollment.PLANTYPE)
            }
        }
    }
    checkBenficiaryValidation() {
        if (this.enrollment.APPFN === undefined || this.enrollment.APPFN === '' || this.enrollment.APPFN === null) {
            this.ErrorMessages.push('First Name is required')
            this.hasError = true
        }
        if (this.enrollment.APPLN === undefined || this.enrollment.APPLN === '' || this.enrollment.APPLN === null) {
            this.ErrorMessages.push('Last Name is required')
            this.hasError = true
        }

        if (this.enrollment.APPDOB === undefined || this.enrollment.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasError = true
        } else {
            let dob = moment(this.enrollment.APPDOB, 'MM/DD/YYYY')
            if (!dob.isValid()) {
                this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                this.hasError = true
            } else {
                if (dob.isSameOrBefore('12/31/1889')) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid Date of Birth.')
                }
            }
        }

        if (this.enrollment.APPGEN === undefined || this.enrollment.APPGEN === '' || this.enrollment.APPGEN === null) {
            this.ErrorMessages.push('Gender is required')
            this.hasError = true
        }
        if (this.enrollment.APPADD1 === undefined || this.enrollment.APPADD1 === '' || this.enrollment.APPADD1 === null) {
            this.ErrorMessages.push('Address1 is required')
            this.hasError = true
        }
        if (this.enrollment.APPCITY === undefined || this.enrollment.APPCITY === '' || this.enrollment.APPCITY === null) {
            this.ErrorMessages.push('City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-. ]+$/

            let isCityValid = regexCityVal.test(this.enrollment.APPCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollment.APPST === undefined || this.enrollment.APPST === '' || this.enrollment.APPST === '0') {
            this.ErrorMessages.push('State is required')
            this.hasError = true
        }
        if (this.enrollment.APPZIP === undefined || this.enrollment.APPZIP === '') {
            this.ErrorMessages.push('Zip is required')
            this.hasError = true
        }

        if (this.enrollment.MAILADD1 === undefined || this.enrollment.MAILADD1 === '') {
            this.ErrorMessages.push('Mailing Address1 is required')
            this.hasError = true
        }
        if (this.enrollment.MAILCITY === undefined || this.enrollment.MAILCITY === '') {
            this.ErrorMessages.push('Mailing City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-. ]+$/

            let isCityValid = regexCityVal.test(this.enrollment.MAILCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }
        //    let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
        //    if (!isCityValid) {
        //        this.hasError = true
        //        this.ErrorMessages.push('Please enter valid Mailing City')
        //    }
        //}
        if (this.enrollment.MAILST === undefined || this.enrollment.MAILST === '' || this.enrollment.MAILST === '0') {
            this.ErrorMessages.push('Mailing State is required')
            this.hasError = true
        }
        if (this.enrollment.MAILZIP === undefined || this.enrollment.MAILZIP === '') {
            this.ErrorMessages.push('Mailing Zip is required')
            this.hasError = true
        }
        if (this.enrollment.MAILZIP !== undefined && this.enrollment.MAILZIP !== '' && this.enrollment.MAILZIP !== null) {
            let checkZipCode = this.enrollment.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip must be exactly 5 numbers')
            }
        }
        if (this.enrollment.APPFN !== undefined && this.enrollment.APPFN !== '' && this.enrollment.APPFN !== null) {
            let checkFName = this.enrollment.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollment.APPLN !== undefined && this.enrollment.APPLN !== '' && this.enrollment.APPLN !== null) {
            let checkLName = this.enrollment.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollment.APPMI !== undefined && this.enrollment.APPMI !== '' && this.enrollment.APPMI !== null) {
            let checkMI = this.enrollment.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }

        if (this.enrollment.APPZIP !== undefined && this.enrollment.APPZIP !== '' && this.enrollment.APPZIP !== null) {
            let checkZipCode = this.enrollment.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip must be exactly 5 numbers')
            }
        }

        if (this.enrollment.APPPHONE !== undefined && this.enrollment.APPPHONE !== '' && this.enrollment.APPPHONE !== null) {
            let checkOrgPhone = this.enrollment.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (this.enrollment.APPEMAIL !== undefined && this.enrollment.APPEMAIL !== '' && this.enrollment.APPEMAIL !== null) {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.enrollment.APPEMAIL.toLowerCase()

            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasError = true
                this.ErrorMessages.push('Email Address is invalid.')
            }
            //this.ErrorMessages.push('Email Address is required for Electronic Explanation of Benefits')
            //this.hasError = true
        }

        if (this.enrollment.PLANST === 'AK' && this.enrollment.PLANTYPE === 'PLUS') {
            this.ErrorMessages.push('SilverScript Plus plan is not available for Alaska state.')
            this.hasError = true
        }
    }
    SelectGender(event: any) {
        this.enrollment.APPGEN = event
        if (this.enrollment.RBLBENFE == 'No') {
            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'
                this.spnyouhimher = 'him'
                this.spnYouheshe = 'he'
                this.spnIsBeneficiary2 = 'he'
                this.spnyouthey = 'they'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'
                this.spnyouhimher = 'her'
                this.spnYouheshe = 'she'
                this.spnIsBeneficiary2 = 'she'
                this.spnyouthey = 'they'
            } else {
                this.spnyouheshe = 'he/she'
                this.spnyourhisher = 'his/her'
                this.spnyouhimher = 'him/her'
                this.spnYouheshe = 'he/she'
                this.spnIsBeneficiary2 = ' he/she '
                this.spnyouthey = 'they'
            }
        }
    }
    setScript() {
        if (this.enrollment.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'you '
            this.spnIsBeneficiary2 = 'you '
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Do '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnyouthey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'you'
            this.spnyourhisher = 'your'
            this.spnYourBeneficiaryNew = 'your '
            this.spnIsBeneficiaryYou = 'you'
            this.spnyouhimher = 'you'
            this.spndodoes = 'do'
            this.spnyoubenef = 'you'
            this.spnYouheshe = 'You'
            this.spnYoutheenrollee = 'you'
            this.spnnameofMedicare = 'you'
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            this.AgentFullName !== ' ' &&
            this.AgentFullName !== '' &&
            this.AgentFullName !== 'undefined undefined'
        ) {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsBeneficiary2 = ' he/she '
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary '
            this.spnIsBeneficiaryYou = 'enrollee'
            this.spndodoes = 'does'
            this.spnyoubenef = 'you as the authorized representative for the beneficiary'
            this.spnYoutheenrollee = this.AgentFullName
            this.spnnameofMedicare = this.AgentFullName
            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'

                this.spnyouhimher = 'him'
                this.spnYouheshe = 'he'
                this.spnIsBeneficiary2 = ' he '
                this.spnyouthey = 'they'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'

                this.spnyouhimher = 'her'
                this.spnYouheshe = 'she'
                this.spnIsBeneficiary2 = ' she '
                this.spnyouthey = 'they'
            } else {
                this.spnyouheshe = 'he/she'
                this.spnyourhisher = 'his/her'

                this.spnyouhimher = 'him/her'
                this.spnYouheshe = 'he/she'
                this.spnyouthey = 'they'
            }
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined' || this.AgentFullName === '')
        ) {
            this.spnIsBeneficiary = ' enrollee’s name'
            this.spnIsBeneficiary2 = '(he/she)'
            this.spnIsAre = 'is'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'they'
            this.spnYourTheir = 'their'
            this.spnHasHave = 'has'
            this.spnIsReside = '(s)'
            this.spnyouheshe = 'he/she'
            this.spnyourhisher = 'his/her'

            this.spnIsBeneficiaryYou = 'enrollee'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary'
            this.spnyouhimher = 'him/her'
            this.spndodoes = 'does'
            this.spnyoubenef = 'you as the authorized representative for the beneficiary'
            this.spnYouheshe = 'he/she'
            this.spnYoutheenrollee = 'the enrollee name'
            this.spnnameofMedicare = 'name of Medicare beneficiary'
            this.spnyouthey = 'they'
        }
        if (this.enrollment.RBLBENFE === undefined || this.enrollment.RBLBENFE === '' || this.enrollment.RBLBENFE === null) {
            this.spnIsBeneficiary = ' you/enrollee’s name'
            this.spnIsBeneficiary2 = 'you/he/she'
            this.spnIsAre = 'is/are'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Do/Does '
            this.spnIsAreCapt = 'Is/Are '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'you/they'
            this.spnYourTheir = 'your/their'
            this.spnHasHave = 'has/have'
            this.spnIsReside = '(s)'
            this.spnyouheshe = 'you/he/she'
            this.spnyourhisher = 'your/his/her'

            this.spnIsBeneficiaryYou = 'you/enrollee'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary'
            this.spnyouhimher = 'you/him/her'
            this.spndodoes = 'do/does'
            this.spnyoubenef = 'you/you as the authorized representative for the beneficiary'
            this.spnYouheshe = 'you/he/she'
            this.spnYoutheenrollee = 'you/the enrollee name'
            this.spnnameofMedicare = 'you/name of Medicare beneficiary'
            this.spnyouthey = 'you/they'
        }
    }

    isNPNmandatory: boolean = false

    // Individual End
    onBlur() {
        if (this.enrollment.ISSAMEADDRESS) this.clickOnSameAsBusinessAddress(true)
    }
}
